import { useCallback } from 'react';
import { pick } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useGetTemporaryAuthenticationToken } from 'js/hooks/auth/hooks/useGetTemporaryAuthenticationToken';

export const useLottoGetTemptoken = () => {
    const { userName, isLoggedIn, sessionStartTime = new Date() } = useUserSelector(pick(['userName', 'isLoggedIn', 'sessionStartTime']));
    const getTemporaryAuthenticationToken = useGetTemporaryAuthenticationToken();

    return useCallback(async (): Promise<{userName?: string; token: string; sessionCreationTime: string} | null> => {
        if (isLoggedIn) {
            const token = await getTemporaryAuthenticationToken();

            return { userName, token, sessionCreationTime: new Date(sessionStartTime).toISOString() };
        }

        return null;
    }, [getTemporaryAuthenticationToken, isLoggedIn, userName, sessionStartTime]);
};
